import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import sellerMarketProductTableColumns from './seller-market-product-table-columns'
import DataTable from 'components/organisms/data-table'


const proptypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.array,
  rowButtonProps : PropTypes.array
}

const defaultProps = {
  rowButtonProps: []
}


/**
 * Domain-specifc DataTable for Seller Market Product
 * @param {object[]} data - array of seller market product objects
 * @param {object} pagination - object of pagination data from endpoint
 * @param {func} onFetchData - function that will call endpoint for data
 * @param {bool} isLoading - whether the table is currently loading data from the backend
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */
const SellerMarketProductTable = ({
  data,
  pagination,
  onFetchData,
  isLoading,
  hiddenColumns,
  rowButtonProps
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const columns = useMemo(() => sellerMarketProductTableColumns({ rowButtonProps }), [ rowButtonProps ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      isLoading= { isLoading }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
    />
  )
}

SellerMarketProductTable.propTypes    = proptypes
SellerMarketProductTable.defaultProps = defaultProps

export default SellerMarketProductTable
